import tw from "twin.macro";

const Nav = tw.div`h-16 bg-white border-b border-gray-200 flex justify-between items-center px-6 shadow-sm`;

export default function Navbar() {
  return (
    <Nav>
      <h3 tw="font-semibold text-lg text-gray-800">Admin Portal</h3>
      <button
        onClick={() => {
          localStorage.removeItem("admin-auth");
          window.location.href = "/login";
        }}
        tw="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded transition duration-300"
      >
        Logout
      </button>
    </Nav>
  );
}
